import { mergeAttributes, Node } from '@tiptap/core';

/**
 * Nodo per la gestione dei Tooltip.
 * È un nodo **virtuale** nel senso che viene utilizzato solo per la generazione
 * dell'HTML, la visualizzazione del tooltip è gestita da
 * `renderRichTextAdvancedNodes` tramite `html-react-parser` che di fatto
 * sostituisce il nodo con un componente React (InfoIcon)
 */
export const TooltipVirtualNode = Node.create({
  name: 'tooltip-virtual-node',
  content: 'paragraph*',
  group: 'inline',
  inline: true,
  parseHTML() {
    return [{ tag: `span[data-type="${this.name}"]`, priority: 51 }];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { 'data-type': this.name }),
    ];
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      content: {
        default: null,
        parseHTML: element => {
          const data = element.getAttribute('data-content');
          return data ?? null;
        },
        renderHTML: attributes => {
          if (!attributes.content) return {};
          return {
            'data-content': attributes.content,
          };
        },
      },
    };
  },
});
